import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Switch,
  Tab,
  Tabs,
  Typography,
} from '@material-ui/core';
import { Add } from '@material-ui/icons';
import ProviderAffiliateSetting from 'components/admin/provider/AffiliateSetting';
import ProviderMaxBetSetting from 'components/admin/provider/ProviderMaxBetSetting';
import _ from 'lodash';
import { useMemo, useState } from 'react';
import { Link, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import useSWR, { mutate } from 'swr';
import { getProviderById, importGames, updateProviderById } from '../../../api/cms/provider';
import Breadcrumbs from '../../../components/Breadcrumbs';
import { LoadingBox } from '../../../components/LoadingBox';
import GameListTable from '../../../components/admin/provider/GameListTable';
import ProviderImageCategory from '../../../components/admin/provider/ProviderImageCategory';
import ProviderInfo from '../../../components/admin/provider/ProviderInfo';
import ApplicationLayout from '../../../components/layouts/ApplicationLayout';
import ProviderCredential from 'components/admin/provider/ProviderCredential';
import ProviderReportConfig from 'components/admin/provider/ProviderReportConfig';

const ProviderInfoPage = () => {
  let { providerId } = useParams();
  let location = useLocation();
  const [providerActive, setProviderActive] = useState(false);
  const [providerAffilates, setProviderAffiliates] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const { data: providerInfo, error: errorProvider } = useSWR(
    ['providerById', providerId],
    (url, providerId) => getProviderById(providerId),
    { revalidateOnFocus: false, refreshInterval: 0, shouldRetryOnError: false },
  );

  if (errorProvider) toast.error('error');

  const ProviderInfoContent = useMemo(() => {
    if (!providerInfo && !errorProvider) return <LoadingBox />;
    if (providerInfo) {
      setProviderActive(providerInfo.is_active);
      setProviderAffiliates(providerInfo.affiliate_settings);
      return <ProviderInfo providerInfo={providerInfo} />;
    }
  }, [providerInfo]);

  const onChangeActive = (is_active) => {
    updateProviderById(providerId, { is_active })
      .then(() => {
        setProviderActive(is_active);
        toast.success('updated');
      })
      .catch((error) => {
        toast.error(_.get(error, 'response.data.message', 'error'));
      });
  };

  const onTabChange = (event, newTab) => {
    setTabValue(newTab);
  };

  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`wrapped-tabpanel-${index}`}
        aria-labelledby={`wrapped-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  };

  const a11yProps = (index) => {
    return {
      id: `wrapped-tab-${index}`,
      'aria-controls': `wrapped-tabpanel-${index}`,
    };
  };

  // const StyledTableRow = withStyles((theme) => ({
  //   root: {
  //     '&:nth-of-type(odd)': {
  //       backgroundColor: theme.palette.action.hover,
  //     },
  //   },
  // }))(TableRow);

  let match = useRouteMatch();
  const handleImportGames = async () => {
    let file = null;

    await Swal.fire({
      title: 'Import Games',
      html: `
      <div id="dropzone"
        style="border: 2px dashed #ccc; padding: 20px; text-align: center; cursor: pointer;">
        <p id="dropzone-text">Click or drag a .json file here</p>
        <input type="file" id="fileInput" accept=".json" style="display: none;" />
      </div>
    `,
      showCancelButton: true,
      confirmButtonText: 'Import',
      didOpen: () => {
        const dropzone = Swal.getPopup().querySelector('#dropzone');
        const fileInput = Swal.getPopup().querySelector('#fileInput');
        const text = Swal.getPopup().querySelector('#dropzone-text');

        dropzone.addEventListener('click', () => fileInput.click());

        fileInput.addEventListener('change', () => {
          if (fileInput.files.length > 0) {
            file = fileInput.files[0];
            text.innerText = `Selected file: ${file.name}`;
          }
        });

        dropzone.addEventListener('dragover', (e) => {
          e.preventDefault();
          dropzone.style.borderColor = '#3f51b5';
        });

        dropzone.addEventListener('dragleave', () => {
          dropzone.style.borderColor = '#ccc';
        });

        dropzone.addEventListener('drop', (e) => {
          e.preventDefault();
          dropzone.style.borderColor = '#ccc';
          const dtFile = e.dataTransfer.files[0];
          if (dtFile) {
            file = dtFile;
            text.innerText = `Selected file: ${file.name}`;
          }
        });
      },
      preConfirm: () => {
        if (!file) {
          Swal.showValidationMessage('Please select a file');
        }
        return file;
      },
    }).then(async (result) => {
      if (result.isConfirmed && result.value) {
        try {
          const imported = await importGames(providerId, result.value);

          // 🔴 Show error if `error` exists in the response
          if (imported?.error) {
            return Swal.fire({
              icon: 'error',
              title: 'Import Failed',
              text: imported?.error?.message || 'An error occurred.',
            });
          }

          // ✅ Show result table
          await Swal.fire({
            title: 'Import Result',
            html: `
            <div style="max-height: 400px; overflow-y: auto;">
              <table style="width: 100%; border-collapse: collapse; font-size: 14px; table-layout: fixed;">
                <thead>
                  <tr style="background: #f0f0f0;">
                    <th style="padding: 8px; text-align: left; border: 1px solid #ccc;">Game Name</th>
                    <th style="padding: 8px; text-align: left; border: 1px solid #ccc;">Game Code</th>
                    <th style="padding: 8px; text-align: left; border: 1px solid #ccc;">Status</th>
                    <th style="padding: 8px; text-align: left; border: 1px solid #ccc;">Error</th>
                  </tr>
                </thead>
                <tbody>
                  ${imported?.game_syncs
                    .map(
                      (item) => `
                        <tr>
                          <td style="padding: 8px; border: 1px solid #ccc;">${
                            item.game?.game_name || '-'
                          }</td>
                          <td style="padding: 8px; border: 1px solid #ccc;">${
                            item.game?.game_code || '-'
                          }</td>
                          <td style="padding: 8px; border: 1px solid #ccc; color: ${
                            item.error ? 'red' : 'green'
                          };">
                            ${item.error ? 'Failed' : 'Success'}
                          </td>
                          <td style="padding: 8px; border: 1px solid #ccc;">${
                            item.error?.message || '-'
                          }</td>
                        </tr>
                      `,
                    )
                    .join('')}
                </tbody>
              </table>
            </div>
          `,
            icon: 'info',
            confirmButtonText: 'OK',
            width: 800,
          });

          // ✅ Refresh game list
          mutate(
            (key) => Array.isArray(key) && key[0] === 'gameByProviderId' && key[1] === providerId,
            undefined,
            { revalidate: true },
          );
        } catch (err) {
          Swal.fire('Import Failed', err.message || 'Unexpected error', 'error');
        }
      }
    });
  };

  return (
    <ApplicationLayout>
      <Grid>
        <Breadcrumbs
          breadcrumbNameAddOn={{ [`${location.pathname}`]: providerInfo?.provider_name }}
        />
        <Tabs value={tabValue} onChange={onTabChange}>
          <Tab label="General" value={0} {...a11yProps(0)} />
          <Tab label="Affiliate / Category" value={1} {...a11yProps(1)} />
          {providerInfo?.category.includes('Live Casino') ? (
            <Tab label="Min/Max Bet Limit" value={2} {...a11yProps(2)} />
          ) : null}
          <Tab label="Credential" value={3} {...a11yProps(3)} />
          <Tab label="Report Config" value={4} {...a11yProps(4)} />
        </Tabs>
        <TabPanel value={tabValue} index={0}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="h6" gutterBottom component="div">
              Provider Info {providerInfo ? `(${providerInfo?.provider_name})` : null}
            </Typography>
            <FormControlLabel
              control={
                <Switch
                  checked={providerActive}
                  onChange={(event) => {
                    onChangeActive(event.target.checked);
                  }}
                />
              }
              label="Active"
            />
          </Box>
          {ProviderInfoContent}
          <Box display="flex" flexDirection="row">
            <Box flexGrow={1}>
              <Typography variant="h6" gutterBottom component="div">
                Game List
              </Typography>
            </Box>
            <Box display="flex" flexDirection="row">
              <Box style={{ padding: '0 10px' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleImportGames}
                  style={{ marginRight: 10 }}
                >
                  Import Games
                </Button>
              </Box>
            </Box>
            <Box style={{ padding: '0 20px' }}>
              <Link to={`${match.url}/game/new`}>
                <Button variant="contained" color="primary" endIcon={<Add />}>
                  New Game
                </Button>
              </Link>
            </Box>
          </Box>
          <Grid item xs={12}>
            {providerAffilates.length > 0
              ? providerAffilates.map((v, i) => (
                  <GameListTable
                    providerId={providerId}
                    categoryName={v.category}
                    config={providerInfo.configs.find((cfg) => cfg.category_code == v.category)}
                    key={i}
                    order={i}
                    refreshTrigger={refreshTrigger}
                  />
                ))
              : null}
          </Grid>
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <Grid item xs={12}>
            <ProviderAffiliateSetting data={providerAffilates} />
          </Grid>
          <Grid item xs={12}>
            <ProviderImageCategory data={providerAffilates} />
          </Grid>
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <Grid item xs={12}>
            <ProviderMaxBetSetting data={providerInfo} />
          </Grid>
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <ProviderCredential data={providerInfo} />
        </TabPanel>
        <TabPanel value={tabValue} index={4}>
          <ProviderReportConfig data={providerInfo} providerId={providerId} />
        </TabPanel>
      </Grid>
    </ApplicationLayout>
  );
};

export default ProviderInfoPage;
